import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Backdrop } from "@mui/material";

const Spinner = ({ isLoading }) => {
  if (!isLoading) return <></>;
  return (
    <Backdrop
      sx={{
        color: "rgb(0,0,0)",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={isLoading}
    >
      <CircularProgress color=" #212129" />
    </Backdrop>
  );
};
export default Spinner;
